import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import ListaDePaisesConstant from 'constants/listaDePaises'

const IdPaisFormGroup = ({ values, setValues, handleChange, iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PAIS' htmlFor='select-idPais' md={2} />
      <Col md={10}>
        <Field name='_idPais'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idPais'
              onChange={e => {
                handleChange(e)
                values._idPais = e.target.value
                values._idDepartamento = ''
                values._idProvincia = ''
                values._idDistrito = ''
                setValues(values)
              }}
            >
              <option value=''>Seleccionar</option>
              {ListaDePaisesConstant.__array.map((val, key) => (
                <option key={key} value={val.ISO2}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdPaisFormGroup)
